<template>
<div class="indexPage" style="height: 100%;">

    <headfix></headfix>
    <div class="common-banner" v-if="articleInfo.smallThumb">
       <div class="bg-img"><img :src="articleInfo.smallThumb"/></div>
    </div>

    <div class="wraper-box" style="position: relative;">
        <div class="article-detail">
            <div class="left">
                <div class="title">{{articleInfo.title}}</div>
                <div class="en-title">{{articleInfo.keywords}}</div>
            </div>
            <div class="right">{{articleInfo.createTime|getMyDate}}</div>
        </div>

        <div class="content" v-html="articleInfo.content"></div>


        <div class="art-hot-list pc">
              <a class="art-hot-item" v-for="(item,index) in hotList" @click="goArticleDetail(item)">
                  <div class="item-pic"><img :src="item.thumb"></div>
                  <div class="item-content">
                      <div class="item-left">
                          <div class="item-title">{{item.title}}</div>
                          <div class="item-short-title">{{item.keywords}}</div>
                      </div>
                      <div class="item-detail"><a href="javascript:;">查看详情</a></div>
                  </div>
              </a>
          </div>

    </div>
    <footerfix></footerfix>



</div>
</template>
<script>
import headfix from '@/components/utils/headfix';
import footerfix from '@/components/utils/footerfix';
import {settingInfo_, categoryTree_, goCate_, goAdv_} from '@/components/js/app'
export default {
    components:{headfix, footerfix},
    data(){
        return{
            articleId:0,
            articleInfo:{},
            hotList:[],
            setting:{}
        }
    },
    mounted() {
       document.querySelector('body').setAttribute('style', 'background-color:#faf9f5')
    },
    created() {
        this.articleId = this.$route.query.id;
        this.currentId = this.$route.query.cateId;
        this.$nextTick(()=>{
            if (this.currentId == 47) {
               this.getAdvData(66);
            }

            this.getArticleInfoData(this.articleId);
            this.getHotListData(this.currentId);
        })
    },
    methods : {
        goCate_,
        goAdv_,
        getArticleInfoData (articleId) {

           this.$post_('api/cms-article/article-info-by-id', {id:articleId}, (res) => {
               if (res.code == 1) {
                   this.articleInfo = res.data;
               } else {
                   this.$message.error(res.message);
               }
           })
       },
        // 分类广告
         getAdvData (positionId) {
             this.$post_('api/adv/adv-list', {catId: positionId}, (res) => {
                 if (res.code == 1) {
                     this.advList = res.data;
                 } else {
                     this.$message.error(res.message);
                 }
             })
         },
        // 热门文章列表
       getHotListData (categoryId) {
            let data = {
                categoryId:categoryId,
                randFlag:"1",
                attr1: 1
            }
            this.$post_('api/cms-article/article-page', {page:1,size:2, data:data}, (res) => {
                if (res.code == 1) {
                    this.hotList = res.data.records;
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        goArticleDetail(item) {
              this.$router.push({path:'/articleDetail', query:{cateId:item.categoryId, id:item.id}});
          },
    }
}
</script>

<style scoped>
.article-detail{display: flex;justify-content: space-between;align-items: center;border-bottom: #dedede 1px solid;padding: 10px 0px;margin-top: 10px;}
.article-detail .left .title{font-size: 24px;font-weight: bold;color: #444444;}
.article-detail .left .en-title{font-size: 14px;color: #CCCCCC;}
.article-detail .right{color: #CCCCCC;}
.content{line-height: 25px;color: #444444;margin-top: 20px;padding-bottom: 20px;}

.art-hot-list{display: flex;justify-content: space-between;margin-top: 40px;margin-bottom: 40px;}
.art-hot-item{width: calc(50% - 30px);cursor: pointer;}
.art-hot-item .item-pic{height: 300px;}
.art-hot-item .item-pic img{width: 100%;height: 100%;object-fit: cover;}
.art-hot-item .item-content{display: flex;justify-content: space-between;align-items: center;margin-top: 20px;}
.item-content .item-left{flex: 1;}
.item-left .item-title{font-size: 20px;font-weight: 500;}
.item-left .item-short-title{font-size: 14px;color: #555555;}
.item-detail{border: #CCCCCC 1px solid;text-align: center;color: #CCCCCC;padding: 4px 8px;font-size: 12px;margin-left: 40px;}
.create-time{margin-top: 20px;color: #545454;}
.item-detail a{}



@media (max-width:1799px){

}
@media (max-width:1199px){

}
@media (max-width:993px){
    .art-hot-list.pc{display: none;}
    .article-detail{padding: 10px;}
    .article-detail .left .title{font-size: 14px;}
    .article-detail .left .en-title{font-size: 12px;}
    .content{line-height: 25px;color: #444444;padding: 10px;}
}

@media (max-width:767px){


}


</style>
